import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function PotenzaHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-1819">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/aMEqb6hKmw5sZZLYgvgJSF/microneedling-potenza.jpg)'
    }} data-id="element-1820" />
      <div className="absolute inset-0 bg-black/50" data-id="element-1821" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-1822">
        <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-1823">
          <div className="mb-6" data-id="element-1824">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-1825">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-1826">
                Treatments
              </a>{' '}
              / Skin
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-1827">
            Be POWERFUL
          </span>

          <h1 className="text-[28px] sm:text-4xl lg:text-[48px] uppercase text-white tracking-tight mb-6 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-1828">
            POTENZA RADIO FREQUENCY MICRONEEDLING
          </h1>

          <div className="space-y-6" data-id="element-1829">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1830">
              Incorporating radio frequency microneedling into your skincare
              regimen can be a preventative measure and help ease the appearance
              of wrinkles, fine lines, scars, stretch marks, and small areas of
              loose skin. At Be CLINICAL, we are proud to offer Potenza RF
              Microneedling, a revolutionary, minimally-invasive treatment that
              stimulates collagen and addresses the common signs of aging.
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-1831">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}